export default __webpack_public_path__ + "static/media/insta.ac2ec4e1.svg";